import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useDocumentTitle = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const updateTitle = () => {
      if (i18n.language === 'da') {
        document.title = 'Omsorgsterapi.dk';
      } else {
        document.title = 'CareAndTherapy.com';
      }
    };

    // Update title on mount and when language changes
    updateTitle();

    // Listen for language changes
    i18n.on('languageChanged', updateTitle);

    // Cleanup listener on unmount
    return () => {
      i18n.off('languageChanged', updateTitle);
    };
  }, [i18n]);
};

